// import { mapTagListFromFormValues } from 'containers/UploadForm/mappings';
import { isEmpty, uniqBy } from 'lodash';

// export const mapUpdateUpload = (data: UploadFormFieldTypes) => {
//   const { title, description, tags, cta, redirectURL } = data;
//   const info = { title, description };
//   // const newTags = { tags: tags.map(item => item.tag).flat() };
//   const newTags = { tags: mapTagListFromFormValues(tags) };

//   const categoryTagRelation = tags
//     .map(category => {
//       if (category.id && category.id !== 'tags' && category.value && category.value.length > 0) {
//         return category.value.map(tag => {
//           if (tag.value) {
//             return { category: category.id, tag: tag.value };
//           } else {
//             return { category: category.id, tagLabel: tag };
//           }
//         });
//       }
//       return false;
//     })
//     .flat()
//     .filter((item: any) => item !== false);

//   return {
//     info,
//     newTags,
//     conversionToCTA: {
//       conversion: cta.value,
//       metadata: {
//         url: redirectURL,
//         target: '_self'
//       }
//     },
//     categoryTagRelation
//   };
// };

export const extractEmbedded = (list: { _embedded: { [x: string]: any } }[], property: string) =>
  list.flatMap((item: { _embedded: { [x: string]: any } }) => item?._embedded?.[property] || []);

export const mapChannelStream = ({ channelList, streamList, placementList }: any) => {
  const {
    _embedded: { channels }
  } = channelList;

  const streams = extractEmbedded(streamList, 'streams');
  const placements = extractEmbedded(placementList, 'placements');

  const finalArray = placements.map((placement: { stream: string; channel: string }) => {
    const channelObj = channels.find((channel: { id: string }) => channel.id === placement.channel);
    const streamObj = streams.find((stream: { id: string }) => stream.id === placement.stream);
    return {
      ...placement,
      ...(!isEmpty(channelObj) && { channel: channelObj }),
      ...(!isEmpty(streamObj) && { stream: streamObj })
    };
  });
  const channelsList = finalArray.map((item: { channel: any }) => item.channel);
  const uniqChannels = uniqBy(channelsList, (item: any) => item.id);
  const streamsList = finalArray.map((item: { stream: any; channel: { name: string } }) => ({
    ...item.stream,
    channel: item.channel.name
  }));
  const uniqStreams = uniqBy(streamsList, (item: any) => item.id);
  return { placements: finalArray, channels: uniqChannels, streams: uniqStreams };
};

export const mapPlacementTags = (taglist: { id: string; name: string }[]) => {
  return taglist.map(item => item.name);
};
